import { View, FlatList, Text, ActivityIndicator } from 'react-native';
import Accordion from '@sharedComponents/Accordion/Accordion';
import gs from '../../styles/globalStyles';
import FaqHeader from './component/Header/Header';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { PrivateStackParamList } from '../../navigationApp/types';
import useSingleRemoteConfig from '../../hooks/useSingleRemoteConfig';
import { ThemedView } from '../../theme'

import {useAppSelector} from '../../store/hooks'
import ScreenWrapper from '@app/hoc/ScreenWrapper';
import { checkColor } from '@app/utils';
const descriptionMap = {
  tata: 'descriptionTata',
  dsp: 'descriptionDSP',
};


type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'FAQ'>;


//TODO - FAQs from Remote config/backend

const Faqs = ({ navigation , route}: ScreenProps) => {
  const userData = useAppSelector(state => state.auth.userDetails);
  const lenderId = userData.linkedApplications[0].lenderAccountId.toLowerCase();

  const { configValue, loading } = useSingleRemoteConfig('faq_data_list')

  const faqData = configValue ? JSON.parse(configValue) : []

  const renderIndividualFAQSection = (item, index) => {
    const description = item[descriptionMap[lenderId]] ?? item?.description;
    return (
      <Accordion id={item.id} title={item.title} description={description} />
    );
  };


  if (loading) {

    return <ThemedView bg='bg-surface-primary' flex={1} justifyContent='center' alignItems='center'>
      <ActivityIndicator color={checkColor('#1434CB')} size={12} />
    </ThemedView>
  }




  return (
    <>
    <ScreenWrapper screenName={route?.name} additionalProperties={{newArchRoute : true }}>
      <FaqHeader navigation={navigation} />
      <ThemedView backgroundColor='bg-surface-primary' flex={1}>
        <FlatList
          contentContainerStyle={{ padding: 16 }}
          data={faqData}
          renderItem={({ item, index }) =>
            renderIndividualFAQSection(item, index)
          }
          keyExtractor={item => item.id}
          initialNumToRender={20} // Increased from default 10
          maxToRenderPerBatch={20}
        />
      </ThemedView>
      </ScreenWrapper>
    </>
  );
};
export default Faqs;
